export default "__VITE_ASSET__Cr0wXNnP__"